// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__20J33","consentsList":"PatientConsents_consentsList__1GDkQ","consentsListEmpty":"PatientConsents_consentsListEmpty__1fjkg"};